import React, { useCallback } from 'react';
import { StatsCard } from 'common/components';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS, TABLES_KEYS } from 'features/command-center/constants';
import { THEME } from 'GlobalStyles';
import useDatatable, { getColumnPreferences, getColumnsToRender } from 'hooks/datatable';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';
import DataTable from 'UI/components/organisms/DataTable';

import { COLUMNS, ORDER_BY_OPTIONS } from './CommissionsBoardSheets.columns';
import { useStyles } from './CommissionsBoardSheets.styles';

const TABLE_KEY = TABLES_KEYS.commissionsBoardTables;
const initialPreferences = getColumnPreferences(TABLE_KEY, 0, ORDER_BY_OPTIONS, COLUMNS);

export const CommissionsBoardSheets = ({ queryParams, onClickRow, selectedRowId }) => {
  const classes = useStyles();
  const endpoint = `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.commissionsBoardSheets}?${queryParams}`;

  const { data, listState, columnPreferences, handleColumnSortChange } = useDatatable({
    apiInstance: SECONDARY_API_CLIENT,
    columnsDefinitions: COLUMNS,
    endpoint,
    initialPreferences,
    orderByOptions: ORDER_BY_OPTIONS
  });

  const { isLoading, showWholeSkeleton } = listState;
  const { columns } = columnPreferences;
  const finalColumns = getColumnsToRender(columns);

  const handleRowClick = rowMeta => {
    onClickRow && onClickRow(data[rowMeta.rowIndex]);
  };

  const setRowProps = useCallback(
    dataIndex => {
      if (!selectedRowId) return null;

      const rowData = data[dataIndex];
      return rowData?.payPeriodId === selectedRowId
        ? { style: { backgroundColor: THEME.palette.primary.FP50 } }
        : null;
    },
    [data, selectedRowId]
  );

  return (
    <StatsCard header={strings.commandCenter.commissionsBoard.leftTableTitle} paddingContent={0}>
      <DataTable
        columns={finalColumns}
        className={classes.table}
        components={{ TableToolbar: () => null }}
        data={data}
        elevation={0}
        expandableRowsHeader={false}
        filter={false}
        loading={showWholeSkeleton}
        onColumnSortChange={handleColumnSortChange}
        onRowClick={handleRowClick}
        refreshing={isLoading}
        search={false}
        selectableRows="none"
        viewColumns={false}
        setRowProps={(row, dataIndex) => setRowProps(dataIndex)}
      />
    </StatsCard>
  );
};
